export default __webpack_public_path__ + "static/media/demo_thermal.3b90ae52.png";